import { combineReducers, configureStore } from "@reduxjs/toolkit";
import permissionReducer from "./slice/permissions";
import getProfileInfoSlice from "./slice/getProfileInfo";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import { persistReducer, persistStore } from "redux-persist";
import taskReducer from "./slice/taskSlice";



// Combine all reducers
const rootReducer = combineReducers({
    permission: permissionReducer,
    profile: getProfileInfoSlice,
    task: taskReducer,
});

// Persist config
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["permission", "profile", "task"],
};

// Wrap combined reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// Create persistor
export const persistor = persistStore(store);